import {
  Select,
  useToast,
} from '@chakra-ui/react';

import React from 'react';
import { useMutation } from 'urql';
import {
  Project,
  TranslationType,
  UpdateProjectDocument,
} from '../../gql/graphql';

type SettingsProps = {
  project: Pick<Project, 'id' | 'settings'>;
};

export default function TranslationTypeTab({
  project,
}: SettingsProps): React.ReactElement {
  const [, updateProject] = useMutation(UpdateProjectDocument);

  const toast = useToast();

  const handleSubmit = async (translationType: TranslationType) => {
    await updateProject({
      input: {
        id: project.id,
        patch: {
          settings: {
            ...project.settings,
            translationType: translationType,
          },
        },
      },
    });
    toast({
      title: 'Translation type updated',
      status: 'success',
    });
  };

  return (
    <>
      IFC translation type - Only modern is officially supported, v3 in alpha
      <Select
        value={
          project.settings?.translationType
            ? project.settings?.translationType
            : 'modern'
        }
        // Patch
        onChange={(e) => handleSubmit(e.target.value as TranslationType)}
      >
        {Object.values(TranslationType).map((value) => (
          <option key={value}>{value}</option>
        ))}
      </Select>
    </>
  );
}
